import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import TrafikSigortasi from './pages/TrafikSigortasi';
import Kasko from './pages/Kasko';
import DaskYenileme from './pages/DaskYenileme'; // DASK Yenileme komponenti
import Hakkimizda from './pages/Hakkimizda';
import KVKK from './pages/KVKK';
import AydinlatmaMetni from './pages/AydinlatmaMetni';
import GizlilikPolitikasi from './pages/GizlilikPolitikasi';
import Mesuliyet from './pages/Mesuliyet';
import TamamlayiciSaglik from './pages/TamamlayiciSaglik';
import TesekkurSayfasi from './pages/TesekkurSayfasi';
import CookieConsent from './components/CookieConsent';
import CerezPolitikasi from './pages/CerezPolitikasi';
import SigortaUrunleri from './pages/SigortaUrunleri';
import FerdiKaza from './pages/FerdiKaza';

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          {/* Ana site rotaları */}
          <Route path="/" element={<HomePage />} />
          <Route path="/trafik-sigortasi" element={<TrafikSigortasi />} />
          <Route path="/kasko" element={<Kasko />} />
          <Route path="/dask-yenileme" element={<DaskYenileme />} /> {/* DASK Yenileme rotası */}
          <Route path="/hakkimizda" element={<Hakkimizda />} />
          <Route path="/kvkk" element={<KVKK />} />
          <Route path="/aydinlatma-metni" element={<AydinlatmaMetni />} />
          <Route path="/gizlilik-politikasi" element={<GizlilikPolitikasi />} />
          <Route path="/ihtiyari-mali-mesuliyet-imm" element={<Mesuliyet />} />
          <Route path="/tamamlayici-saglik-sigortasi" element={<TamamlayiciSaglik />} />
          <Route path="/tesekkurler" element={<TesekkurSayfasi />} />
          <Route path="/cerez-politikasi" element={<CerezPolitikasi />} />
          <Route path="/sigorta-urunleri" element={<SigortaUrunleri />} />
          <Route path='/ferdi-kaza-sigortasi' element={<FerdiKaza />} />
        </Routes>
        <CookieConsent />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;